module.exports = __webpack_public_path__ + "static/RR3-e3a9eabbca19936d1eed0a8c8e350587.jpg";